<div class="animated fadeIn tooltip-container {{setDirection}}">

	<div class="dark-tooltip dark small forecast-detail-hover-tooltip {{setDirection}}">
		<div class="tooltip-content forecast-detail-hover" [innerHTML]="htmlContent">

		</div>
	</div>
	<div class="tooltip-tip"></div>
</div>
